<template>
  <div style="text-align: center;" :class="{ 'auction-page': auctionPageStyle, 'grey-box-container': auctionPageStyle }">

    <template v-if="auctionPageStyle">
      <img :src="require('../../assets/pfx-logo-black.png')" style="height: 2rem; vertical-align: middle; padding-right: 1rem; border-right: 1px solid #000;"/>
      <span style="text-transform: uppercase; font-weight: 600; letter-spacing: 1px; padding-left: 1rem;">How does it work?</span>
    </template>

    <div class="clearfix columns">
      <div class="column">
        <div><img :src="require('../../assets/hdiw-prospect.png')" /></div>
        <h3>Due Diligence</h3>
        <p>Due diligence is done prior to the auction start date. Open the document vault, and set up a viewing with the agent.</p>
      </div>
      <div class="column">
        <div><img :src="require('../../assets/hdiw-register.png')" /></div>
        <h3>Register</h3>
        <p>Register with your PFX account to be eligable to bid in the auction. You will need to supply the required documents.</p>
      </div>
      <div class="column">
        <div><img :src="require('../../assets/hdiw-bid.png')" /></div>
        <h3>Bid</h3>
        <p>When the auction opens, bid online. You can set up autobids and notifications.</p>
      </div>
      <div class="column">
        <div><img :src="require('../../assets/hdiw-win.png')" /></div>
        <h3>Win</h3>
        <p>Due diligence is done prior to the auction start date. Open the document vault, and set up a viewing with the agent.</p>
      </div>
    </div>

    <router-link to="/about">Learn more</router-link>
  </div>
</template>

<script>
  export default {
    name: 'HowDoesItWork',
    props: {
      auctionPageStyle: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../../pfx.scss';

  .auction-page {
    margin: 6rem 0;

    .columns {
      margin: 2rem 4rem;
    }
  }

  .columns {
    text-align: left;
  }

  .column {
    @include column(1/4);

    h3 {
      font-weight: 600;
      font-size: 1.2rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/HowDoesItWork.vue